import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { AppButton } from "components/common/buttons";

const DeleteConfirmDialog = ({ open, title, message, submitting, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ elevation: 0 }}>
    <DialogTitle sx={{ fontWeight: 600 }} color="error">
      {title || "Xác nhận xóa"}
    </DialogTitle>
    <DialogContent>
      {message || "Bạn có chắc chắn muốn xóa dữ liệu này?"}
    </DialogContent>
    <DialogActions>
      <AppButton variant="outlined" onClick={onClose} disabled={submitting}>
        Hủy
      </AppButton>
      <AppButton color="error" variant="contained" onClick={onConfirm} disabled={submitting} disableElevation>
        {submitting ? <CircularProgress size={22} /> : "Xóa"}
      </AppButton>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmDialog;
